import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BookingClassIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BookingClassGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M20.0946 21.0027H3.90538C2.85449 21.0027 2 20.1477 2 19.0973V9.67675C2 8.62641 2.85449 7.77138 3.90538 7.77138H20.0946C21.1455 7.77138 22 8.62641 22 9.67675V19.0973C22 20.1477 21.1455 21.0027 20.0946 21.0027ZM3.90538 8.88249C3.46756 8.88249 3.11111 9.23839 3.11111 9.67675V19.0973C3.11111 19.5357 3.46756 19.8916 3.90538 19.8916H20.0946C20.5324 19.8916 20.8889 19.5357 20.8889 19.0973V9.67675C20.8889 9.23839 20.5324 8.88249 20.0946 8.88249H3.90538Z"
        fill={fill}
      />
      <path
        d="M14.053 13.6329H9.94652C8.98297 13.6329 8.19955 12.8495 8.19955 11.886C8.19955 10.9224 8.98297 10.139 9.94652 10.139H14.053C15.0165 10.139 15.7999 10.9224 15.7999 11.886C15.7999 12.8495 15.0165 13.6329 14.053 13.6329ZM9.94652 11.2501C9.59604 11.2501 9.31066 11.5355 9.31066 11.886C9.31066 12.2364 9.59604 12.5218 9.94652 12.5218H14.053C14.4034 12.5218 14.6888 12.2364 14.6888 11.886C14.6888 11.5355 14.4034 11.2501 14.053 11.2501H9.94652Z"
        fill={fill}
      />
      <path
        d="M18.6401 8.88249H18.6336L9.19239 8.77506C8.96887 8.7729 8.76867 8.63618 8.68458 8.42893C8.59995 8.22169 8.64824 7.98514 8.80611 7.82672L13.473 3.15983C13.69 2.94282 14.0416 2.94282 14.2586 3.15983L19.0329 7.93414C19.1924 8.09364 19.2396 8.33453 19.1523 8.54286C19.0655 8.74903 18.8636 8.88249 18.6401 8.88249ZM10.5249 7.67914L17.2832 7.75619L13.8658 4.33822L10.5249 7.67914Z"
        fill={fill}
      />
      <path
        d="M9.20053 8.7729H9.19401L5.35287 8.7295C5.12935 8.72733 4.92915 8.59061 4.84506 8.38336C4.76042 8.17612 4.80871 7.93958 4.96659 7.78115L8.73558 4.01271C8.95259 3.7957 9.30416 3.7957 9.52117 4.01271L11.4634 5.95499C11.5676 6.05915 11.6262 6.20021 11.6262 6.34779C11.6262 6.49536 11.5676 6.63642 11.4634 6.74059L9.59333 8.61016C9.48916 8.71433 9.34756 8.7729 9.20053 8.7729ZM6.68588 7.63358L8.9732 7.65962L10.285 6.34777L9.12836 5.19108L6.68588 7.63358Z"
        fill={fill}
      />
    </svg>
  );
};

export default BookingClassIcon;
